import { render } from "./SeparateRecommendedLessonTest.vue?vue&type=template&id=bde234b8&scoped=true"
import script from "./SeparateRecommendedLessonTest.vue?vue&type=script&lang=js"
export * from "./SeparateRecommendedLessonTest.vue?vue&type=script&lang=js"

import "./SeparateRecommendedLessonTest.vue?vue&type=style&index=0&id=bde234b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde234b8"]])

export default __exports__